export default (() => {

    const defaultSize = 50;
    const resizeFactor = 1.8;
    const sliderButtonIncrementSize = 5;
    const global = {
        elements: {},
        inputs: {},
        data:{},
        pageData:{},
    };

    function initialise() {
        _cacheDom();
        _cachePageData();
        _bindCanvas();
        _bindComponents();
        _bindEvents();
    }

    function _cacheDom () {
        global.elements.canvas = document.querySelector('[data-signature-box]');
        global.elements.modalTimeToEdit = document.querySelector('[data-modal-time-to-edit]');
        global.elements.slider = document.querySelector('[data-slider-size]');
        global.elements.buttonRotate = document.querySelector('[data-button-signature-rotate]');
        global.elements.buttonReset = document.querySelector('[data-button-signature-reset]');
        global.elements.deleteImageButton = document.querySelector('[data-delete-image-button]');
        global.inputs.editedImage = document.querySelector('#EditedImage');
    }

    function _cachePageData () {
        global.pageData.mobileUploadUrl = document.querySelector('[data-mobileuploadurl]').dataset.mobileuploadurl;
        global.pageData.desktopUploadUrl = document.querySelector('[data-desktopuploadurl]').dataset.desktopuploadurl;
    }

    function _bindCanvas () {
        global.data.canvas = new wealthify.canvas.DraggableImage(global.elements.canvas, global.elements.canvas.dataset.imageSrc);
    }

    function _bindComponents () {
        const ranges = {};

        let current = 0;

        while (current <= 100) {
            ranges[current] = [current, sliderButtonIncrementSize];
            current = current + sliderButtonIncrementSize;
        }

        global.elements.slider.ranges = ranges;

        global.elements.deleteImageButton.link = wealthify.user.isOnMobileDevice() ? global.pageData.mobileUploadUrl : global.pageData.desktopUploadUrl;
    }

    function _bindEvents () {
        global.elements.buttonRotate.addEventListener('click', _rotateImage);
        global.elements.buttonReset.addEventListener('click', _resetImage);
        global.elements.canvas.addEventListener('canvaschange', _saveImageAndEnableResetButton);
        global.elements.slider.addEventListener('valuechange', _updateImageSize);
    }

    function _rotateImage () {
        global.data.canvas.rotate();
    }

    function _resetImage () {
        global.data.canvas.reset();
        global.elements.slider.value = defaultSize;
        global.elements.buttonReset.disabledProp = true;
    }

    function _saveImageAndEnableResetButton () {
        if (global.elements.buttonReset.disabledProp) {
            global.elements.buttonReset.disabledProp = false;
        }

        global.inputs.editedImage.value = global.data.canvas.toBase64String;
    }

    function _updateImageSize () {
        const resizeFraction = ((global.elements.slider.value - defaultSize) * resizeFactor) / 100;

        const resizeValue = 1 + resizeFraction;

        global.data.canvas.resize(resizeValue);
    }

    return { initialise };
})();